module.exports = __webpack_public_path__ + "img/Vest Worn.ec3b37fa.png";